import React  from 'react';
import '../myutils';
import {
    Datagrid,
    DisabledInput,
    Edit,
    EditButton,
    List, 
    NumberField,
    Responsive,
    SelectInput,
    Show,
    ShowButton,
    SimpleForm,
    SimpleList,
    TextField,
    TextInput,
    SimpleShowLayout
} from 'react-admin'; 
const PostEditActions = () => (
    <div></div>
);

export const CampaignList = props => (
    <List
        {...props}
        sort={{ field: 'published_at', order: 'DESC' }}
    >
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.title}
                />
            }
            medium={
                <Datagrid>
                    <TextField source="campaignId" />
                    <TextField source="campaignStatus" />
                    <NumberField source="callerId" />
                    <NumberField source="templateId" />
                    <NumberField source="blockedEntries" />
                    <NumberField source="pendingEntries" />
                    <NumberField source="activeEntries" />
                    <NumberField source="bridgedEntries" />
                    <NumberField source="redialEntries" />
                    <NumberField source="doneEntries" />
                    <NumberField source="failedEntries" />
                    <NumberField source="totalEntries" />
                    <NumberField source="totalDialed" />
                    <NumberField source="totalSuccessful" />
                    <NumberField source="totalBridged" />
                    <NumberField source="totalFailed" />
                    <NumberField source="totalIncoming" />
                    <NumberField source="currentPrice" />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            }
        />
    </List>
);

export const CampaignEdit = (props, {translate}) => (
    <Edit actions ={<PostEditActions />} {...props}>
    
        <SimpleForm redirect="campaigns">
            <DisabledInput source="campaignId" />
            <SelectInput source="action" choices={[
                { id: 'stop', name: 'stop' },
                { id: 'setPaused', name: 'setPaused' },
                { id: 'setMaxActiveChannels', name: 'setMaxActiveChannels' },
                { id: 'setMaxBridgedChannels', name: 'setMaxBridgedChannels' },
            ]} />            
            <TextInput source="value" />
        </SimpleForm>
    </Edit>
);


export const CampaignShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="campaignId" />
            <TextField source="campaignStatus" />
            <TextField source="templateId" />
            <TextField source="blockedEntries" />
        </SimpleShowLayout>
    </Show>
);